import { useSelector } from "react-redux";
import { selectSavedAffiliate } from "~/feature/Affiliate/redux/selectors";

export function usePreferredSalesPartner() {
  return useSelector(selectSavedAffiliate);
}
